import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IInfrastructureOfferRespond } from '@/shared/model/infrastructure-offer-respond.model';

const baseApiUrl = 'api/infrastructure-offer-responds';

export default class InfrastructureOfferRespondService {
  public find(id: number): Promise<IInfrastructureOfferRespond> {
    return new Promise<IInfrastructureOfferRespond>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findForRequestRespond(requestRespondId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + '/find-for-request-respond/' + `${requestRespondId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IInfrastructureOfferRespond): Promise<IInfrastructureOfferRespond> {
    return new Promise<IInfrastructureOfferRespond>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IInfrastructureOfferRespond): Promise<IInfrastructureOfferRespond> {
    return new Promise<IInfrastructureOfferRespond>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
